import { render, staticRenderFns } from "./e-button-close.vue?vue&type=template&id=642eed66&scoped=true&lang=pug"
import script from "./e-button-close.vue?vue&type=script&lang=js"
export * from "./e-button-close.vue?vue&type=script&lang=js"
import style0 from "./e-button-close.vue?vue&type=style&index=0&id=642eed66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642eed66",
  null
  
)

export default component.exports